import { call, put } from 'redux-saga/effects';
import {
  revokePaitentByUserFailure,
  revokePaitentByUserRequest,
  revokePaitentByUserSuccess,
} from '../actions';
import { urls } from '../constants/constants';
import * as SagaTypes from './saga-types';
import * as Api from '../api';

export function* convertClaimedToUnclaimed(action) {
  yield put(revokePaitentByUserRequest());
  const patientId = action.payload.param.patientId;
  try {
    const result = yield call(
      Api.get,
      `${urls.aspariaBackend}api/v1/patient/revokePatient/${patientId}`
    );
    if (result) {
      action.callback();
      yield put(revokePaitentByUserSuccess(result.data.data));
    } else {
      yield put(revokePaitentByUserFailure('Something went Wrong'));
    }
  } catch (e) {
    yield put(revokePaitentByUserFailure(e));
  }
}

export const revokePatientByUser = (param, cb) => ({
  type: SagaTypes.CONVERT_CLAIMED_TO_UNCLAIMED_PATIENT,
  payload: { param },
  callback: cb,
});
